import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaVideo,
  FaStar,
  FaRocket,
  FaUsers,
  FaMobileAlt,
  FaCheckCircle,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const BestVideoProductionServicesInBurDubai = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Best Video Production Services in Bur Dubai" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Transform Your Vision</Subheading>}
        heading={
          <Heading>
            Best <span tw="text-primary-500">Video Production Services</span> in
            Bur Dubai
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we offer the best video production services in
            **Bur Dubai**, delivering captivating visuals and compelling
            storytelling to elevate your brand. Create videos that resonate and
            perform with our expert team.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1601506521937-0121a7fc2a6b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1578302758063-0ef3e048ca89?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Start Your Project"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Top Video Production in Bur Dubai"
        description="We deliver professional video production services tailored to your needs."
        cards={[
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Cinematic Quality",
            description: "High-quality visuals that captivate audiences.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Award-Winning Team",
            description: "Experienced professionals with proven results.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast Turnaround",
            description: "Timely delivery without compromising quality.",
          },
          {
            icon: <FaUsers color="#ff5464" size={40} />,
            title: "Client-Centric Approach",
            description: "Customized solutions for your brand.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Multi-Platform Ready",
            description: "Videos optimized for all devices and platforms.",
          },
          {
            icon: <FaCheckCircle color="#ff5464" size={40} />,
            title: "Trusted in Bur Dubai",
            description: "Preferred choice for local businesses.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Video Production Process"
        description={
          <Description>
            We create impactful videos with a streamlined process:
            <ul tw="mt-4 list-disc pl-6">
              <li>Consultation: Understand your goals and vision.</li>
              <li>Storyboarding: Craft a compelling narrative.</li>
              <li>Filming: Capture stunning visuals with top equipment.</li>
              <li>Editing: Polish with effects, sound, and color grading.</li>
              <li>Delivery: Provide ready-to-use videos.</li>
              <li>Support: Offer ongoing assistance and updates.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1582152629442-4a864303fb96?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1509281373149-e957c6296406?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1570727624862-3008fe67a6be?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Video Production Wins in Bur Dubai"
        description="Our videos have transformed brands across industries."
        cards={[
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Viral Campaigns",
            description: "Boosted engagement with creative ads.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Brand Recognition",
            description: "Enhanced visibility for local businesses.",
          },
          {
            icon: <FaCheckCircle color="#ff5464" size={40} />,
            title: "Client Satisfaction",
            description: "95% approval from Bur Dubai clients.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready for Stunning Videos?</Subheading>}
        heading="Best Video Production in Bur Dubai"
        description={
          <Description>
            Partner with MilaajBrandset for top-tier video production services
            in Bur Dubai. Get professional, high-impact videos that elevate your
            brand—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1524658751880-16a600520565?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1605130284535-11dd9eedc58a?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1485846234645-a62644f84728?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
